import { render, staticRenderFns } from "./giftDetail.vue?vue&type=template&id=46f0b3fb&scoped=true"
import script from "./giftDetail.vue?vue&type=script&lang=js"
export * from "./giftDetail.vue?vue&type=script&lang=js"
import style0 from "./giftDetail.vue?vue&type=style&index=0&id=46f0b3fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f0b3fb",
  null
  
)

export default component.exports